function formatId(id) {
  const idFormat = id?.toString().padStart(5, 0);
  if (!idFormat || id === '' || id === null) return null;
  return `CS-${idFormat}`;
}

function compactFormatId(id) {
  const idFormat = id?.toString().padStart(5, 0);
  if (!idFormat || id === '' || id === null) return null;
  return `CS${idFormat}`;
}

export { formatId, compactFormatId };
